(function () {
	'use strict';

	angular.module('qbePortal').directive('qbFrequentlyAskedQuestions',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbFrequentlyAskedQuestions.html',
				restrict: 'E',
				scope: {
					frequentlyAskedQuestions: '=',
					frequentlyAskedQuestionsTitle: '='
				}, 
			    transclude: true,							
				link: function (scope, element, attrs) {					
					
				}
			};
		});

})();
